import { Button } from 'rsuite';
import { useUser } from '../../contexts/user';
import DoctorsImage from '../../assets/icons/doctors.svg';
import { FofLogin } from '../../components/basic/fof-login';
import Background from '../../assets/icons/doctor_small.png';
import { useQuery } from 'react-query';
import { getDiagnosisFields } from '../../core';
import { CustomLoader } from '../../components/basic/loader';
import { useDiagnosis } from '../../contexts/diagnosis';
import { useNavigate } from 'react-router-dom';

export const Examination = () => {
  const { setDiagnosis } = useDiagnosis();
  const { user } = useUser();
  const navigate = useNavigate();

  const examination = useQuery({
    queryKey: ['examinations'],
    queryFn: async () => {
      const res = await getDiagnosisFields();
      console.log(res.data.data.data);
      return res.data.data.data;
    }
  });

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const handleSetDiagnosis = (item: any) => {
    setDiagnosis(item);
    navigate(`/examination/tnc`);
  };

  return (
    <>
      {user.isLoggedIn ? (
        <div className="px-5 pt-5 pb-5 text-base1 text-justify relative" style={{ zIndex: 1 }}>
          <div
            className="w-[100%] absolute top-0 left-0"
            style={{ zIndex: -1, height: 'calc(100vh - 112px)' }}>
            <img className="w-[100%] h-[100%]" src={Background} alt="" />
          </div>
          <p style={{ lineHeight: '175%' }}>
            در این قسمت از برنامه شما می توانید با چت کردن با یک ربات هوشمند و ارایه شرح حال دقیق
            خود، به یک تشخیص اولیه برپایه هوش مصنوعی برسید. این تشخیص به یافتن مشکل و روند بهبودی
            شما کمک می کند. همچنین در انتهای روند تشخیصی یک پزشک متخصص توصیه هایی به شما ارایه خواهد
            کرد. برای شروع روند تشخیص، یک موضوع را انتخاب کنید.
          </p>

          <div className="flex flex-col items-center mt-10">
            {examination.isLoading ? (
              <CustomLoader />
            ) : (
              <>
                {/* eslint-disable-next-line @typescript-eslint/no-explicit-any */}
                {examination.data.map((item: any) => (
                  <Button
                    key={item.id}
                    size="lg"
                    disabled={!item.is_available}
                    className="btn-opec mt-4 !rounded-xl opacity-80 !text-[--rs-black] w-[75%]"
                    onClick={() => handleSetDiagnosis(item)}>
                    {item.visit_disease_name}
                  </Button>
                ))}
              </>
            )}
          </div>
        </div>
      ) : (
        <FofLogin
          image={DoctorsImage}
          text="در این قسمت شما می توانید یک روند تشخیص را برای یافتن علت درد خود طی کنید و همچنین در انتها روند تشخیص، یک پزشک متخصص به شما توصیه های درمانی برای بهبود وضعیتتان ارایه می دهد."
          redirect="/examination"
        />
      )}
    </>
  );
};
